<template>
    <div>
        <navView :isSelect="isSelect" @handleCommand="handleCommand" />
        <div class="wrap">
            <div class="mask">
                <div class="box">
                    <p>{{ $t('from.service01') }}</p>
                    <p>{{ $t('from.service02') }}</p>
                    <p class="tips">{{ $t('from.service03') }}</p>
                </div>
            </div>
        </div>
        <div class="service">
            <h2>{{ $t('from.service') }}</h2>
            <div class="service-box">
                <div class="service-item" v-for="(item, index) in srcList" :key="index">
                    <img class="el-image" :src="item.url" style="max-width: 100%; height: auto;">

                    <div class="service-title">{{ item.title }}</div>
                </div>
            </div>
        </div>
        <footerView />
    </div>
</template>

<script>
import navView from '../components/nav.vue';
import footerView from '../components/footer.vue';
export default {
    components: {
        navView, footerView
    },
    data() {
        return {
            srcList: [],
            isSelect: 0
        }
    },
    computed: {
        list() {

        }
    },
    created() {
        this.isSelect = Number(this.$route.query.index)
        if (window.sessionStorage.getItem('language') == 'en') {
            this.$i18n.locale = 'en'
            this.onEnList()
        } else {
            this.$i18n.locale = 'zh'
            this.onzhList()
        }

    },
    methods: {
        onEnList() {
            this.srcList = [
                {
                    url: 'https://img.sdaily.cn/WechatIMG187.png', title: 'protac Design'
                },
                {
                    url: 'https://img.sdaily.cn/WechatIMG188.png', title: 'Molecular docking'
                },
                {
                    url: 'https://img.sdaily.cn/WechatIMG189.png', title: 'Molecular dynamics analogy'
                },
                {
                    url: 'https://img.sdaily.cn/WechatIMG190.png', title: 'DFT calculation'
                },
                {
                    url: 'https://img.sdaily.cn/WechatIMG191.png', title: 'chemical synthesis'
                },
                {
                    url: 'https://img.sdaily.cn/WechatIMG192.png', title: 'Biological evaluation'
                },
            ]
        },
        onzhList() {
            this.srcList = [
                {
                    url: 'https://img.sdaily.cn/WechatIMG187.png', title: 'PROTAC设计'
                },
                {
                    url: 'https://img.sdaily.cn/WechatIMG188.png', title: '分子對接'
                },
                {
                    url: 'https://img.sdaily.cn/WechatIMG189.png', title: '分子动力学模拟'
                },
                {
                    url: 'https://img.sdaily.cn/WechatIMG190.png', title: 'DFT計算'
                },
                {
                    url: 'https://img.sdaily.cn/WechatIMG191.png', title: '化学合成'
                },
                {
                    url: 'https://img.sdaily.cn/WechatIMG192.png', title: '生物活性评价'
                },
            ]
        },
        handleCommand(name) {
            if (name == 'en') {
                this.$i18n.locale = 'en'
                this.onEnList()
            } else {
                this.$i18n.locale = 'zh'
                this.onzhList()
            }
        }
    }
}

</script>

<style lang="scss" scoped>
@media only screen and (max-width: 750px) {
    .wrap {
        background: url('../assets/images/bg1.jpg');
        background-repeat: no-repeat;
        background-size: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding-top: 60px;

        .mask {
            width: 100%;
            height: 100%;
            padding: 20px;
            box-sizing: border-box;
            background-color: rgba(0, 0, 0, 0.5);

            .box {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

            p {
                font-size: 16px;
                line-height: 26px;
                color: #fff;
            }

            .tips {
                border: 1px solid #fff;
                border-radius: 6px;
                padding: 3px 8px;
                font-size: 12px;
                margin-top: 10px;
                display: inline;
            }

        }
    }

    .service {
        padding: 15px;

        h2 {
            margin: 20px 0;
            font-size: 18px;
        }

        .service-box {

            margin-top: 20px;

            .service-item {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .el-image {
                    width: 90%;
                    border-radius: 6px;
                    box-shadow: 10px 10px 0px 1px rgba(0, 0, 0, 0.07);
                }

                .service-title {
                    color: #192a3d;
                    font-weight: bold;
                    font-size: 14px;
                    margin: 20px;
                }
            }
        }
    }
}

@media only screen and (min-width: 751px) {
    .wrap {
        background: url('../assets/images/bg1.jpg');
        background-repeat: no-repeat;
        background-size: 100% 100vh;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding-top: 120px;

        .mask {
            width: 100%;
            height: 100%;
            padding: 120px;
            box-sizing: border-box;
            background-color: rgba(0, 0, 0, 0.5);

            .box {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

            p {
                font-size: 42px;
                line-height: 62px;
                color: #fff;
            }

            .tips {
                border: 1px solid #fff;
                border-radius: 6px;
                padding: 6px 16px;
                font-size: 20px;
                margin-top: 10px;
                display: inline;
            }

        }
    }

    .service {
        padding: 30px 120px;

        h2 {
            margin: 40px 0;
        }

        .service-box {
            display: flex;
            flex-wrap: wrap;
            margin-top: 20px;

            .service-item {
                width: 33%;
                display: flex;
                flex-direction: column;
                align-items: center;

                .el-image {
                    border-radius: 6px;
                    transition: transform 0.5s ease-in-out;
                    transform: scale(1);
                    box-shadow: 10px 10px 0px 1px rgba(0, 0, 0, 0.07);
                }

                .el-image:hover {
                    transform: scale(1.1);
                }

                .service-title {
                    color: #192a3d;
                    font-weight: bold;
                    font-size: 20px;
                    margin: 30px;
                }
            }
        }
    }
}
</style>